"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCartCheckoutSuccessData = void 0;
var transformBffToJerichoItem_1 = require("./transformBffToJerichoItem");
var transformTaxDetails_1 = require("./transformTaxDetails");
function transformCartCheckoutSuccessData(data) {
    var checkoutStatus = data.checkoutStatus, paymentProcessor = data.paymentProcessor, orderKey = data.orderKey, orderDate = data.orderDate, orderPlaced = data.orderPlaced, adobeData = data.adobeData, items = data.items, rio = data.rio, promotions = data.promotions, id = data.id, token = data.token;
    var summary = (data.summary || {});
    var discount = summary.discount, currencyCode = summary.currencyCode, orderGiftCodeBalance = summary.orderGiftCodeBalance, totalCoveredByGiftBalance = summary.totalCoveredByGiftBalance, formattedSummary = summary.formattedSummary, estimatedTax = summary.estimatedTax, taxDetails = summary.taxDetails, totalBeforeTax = summary.totalBeforeTax, remainingOrderAmountAfterGiftBalance = summary.remainingOrderAmountAfterGiftBalance;
    var _a = formattedSummary || {}, taxWithCurrencyFormat = _a.estimatedTax, formattedTaxDetails = _a.taxDetails, totalBeforeTaxWithCurrencyFormat = _a.totalBeforeTax, remainingOrderAmountAfterGiftBalanceWithCurrencyFormat = _a.remainingOrderAmountAfterGiftBalance;
    var cartHasPromotions = (promotions === null || promotions === void 0 ? void 0 : promotions.length) > 0;
    return {
        cartId: id,
        checkoutStatus: checkoutStatus,
        paymentProcessor: paymentProcessor,
        orderKey: orderKey,
        orderDate: orderDate,
        orderPlaced: orderPlaced,
        coupon: cartHasPromotions
            ? {
                isEligible: true,
                code: promotions[0].code,
                errorMessage: null,
                discount: discount,
            }
            : null,
        couponError: null,
        token: token !== null && token !== void 0 ? token : null,
        existingSubscriptions: [],
        adobeData: adobeData !== null && adobeData !== void 0 ? adobeData : null,
        rio: rio !== null && rio !== void 0 ? rio : null,
        items: items && summary ? (0, transformBffToJerichoItem_1.transformBffToJerichoItem)(items, summary) : [],
        //@TODO after BFF 100% we should remove mappings and just use fields as they come back from BFF.
        orderSummary: {
            currencyName: currencyCode,
            subtotal: totalBeforeTax,
            total: remainingOrderAmountAfterGiftBalance,
            tax: estimatedTax,
            orderGiftCodeBalance: Number(orderGiftCodeBalance),
            totalCoveredByScholarship: totalCoveredByGiftBalance,
            discount: discount,
            totalWithCurrencyFormat: remainingOrderAmountAfterGiftBalanceWithCurrencyFormat,
            taxWithCurrencyFormat: taxWithCurrencyFormat,
            subtotalWithCurrencyFormat: totalBeforeTaxWithCurrencyFormat,
            taxDetails: taxDetails && formattedTaxDetails
                ? (0, transformTaxDetails_1.transformTaxDetails)(taxDetails, formattedTaxDetails)
                : [],
        },
    };
}
exports.transformCartCheckoutSuccessData = transformCartCheckoutSuccessData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformCartCheckoutSuccessData.js
// module id = 3373
// module chunks = 11